import React from 'react';
import { LinkButton } from '@domain-group/fe-blueprint-ui/button';
import { FeedbackIcon } from '@domain-group/fe-co-icon';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import { Avatar } from '../../shared';

import * as styles from './appraisal-cta.style';
import { buildAppraisalUrl } from '../../../utils';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../../shared/average-star-rating-and-total';
import { OverallStarRating } from '../../shared/recommendations/types';
import useIsDesktop from '../../../hooks/use-is-desktop';

type AppraisalCTAProps = {
  contactId?: number;
  name?: string;
  thumbnail?: string;
  url?: string;
  overallStarRating?: OverallStarRating;
  onClick?: () => void;
  onVendorTotalReviewsClick?: () => void;
};

const AppraisalCTA = ({
  contactId,
  name,
  thumbnail,
  url,
  overallStarRating,
  onClick,
  onVendorTotalReviewsClick,
}: AppraisalCTAProps): JSX.Element => {
  const showRating =
    overallStarRating && Boolean(overallStarRating?.totalReviews);
  const isDesktop = useIsDesktop();

  return (
    <div css={styles.card} data-testid="appraisal-cta">
      <Stack vertical>
        <Avatar
          imageUrl={thumbnail}
          imageTitle={name}
          css={styles.avatar(showRating)}
        />
        {showRating && !isDesktop && (
          <AverageStarRatingAndTotal
            section={STAR_RATING_SECTION.MOBILE}
            averageRating={overallStarRating.rating}
            totalReviews={overallStarRating.totalReviews}
            scrollTo
            onVendorTotalReviewsClick={onVendorTotalReviewsClick}
          />
        )}
      </Stack>

      <div css={styles.content(showRating && !isDesktop)}>
        <div css={styles.copies}>
          <p css={styles.title}>
            Looking to sell{name ? ` with ${name}` : ''}?
          </p>
          <p css={styles.description}>
            Start your selling journey with a free property appraisal
          </p>
          {showRating && isDesktop && (
            <AverageStarRatingAndTotal
              section={STAR_RATING_SECTION.AGENT_CARDS_DARK}
              averageRating={overallStarRating.rating}
              totalReviews={overallStarRating.totalReviews}
              scrollTo
              onVendorTotalReviewsClick={onVendorTotalReviewsClick}
            />
          )}
        </div>

        <LinkButton
          href={
            url ||
            buildAppraisalUrl({
              contactId,
              entryPoint: 'Agent Profile - Appraisal CTA',
            })
          }
          target="_blank"
          css={styles.button}
          onClick={onClick}
        >
          <FeedbackIcon />
          Get a free appraisal
        </LinkButton>
      </div>
    </div>
  );
};

export default AppraisalCTA;
